
export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    shouldShowButton() {
      return this.blok.show_signup_button === true
    }
  },
  methods: {
    brazeSignUp() {
      if (this.$braze) {
        this.isLoading = true
        
        // Use event name from Storyblok or default to Show_Breakfast_Sweeps_Form
        const eventName = this.blok.braze_event_name || 'Show_Breakfast_Sweeps_Form'
        this.$braze.logCustomEvent(eventName)
        
        // Force immediate data flush to reduce IAM re-trigger delay
        if (this.$braze.requestImmediateDataFlush) {
          this.$braze.requestImmediateDataFlush()
        }
        
        // Reset loading state after 5 seconds
        setTimeout(() => {
          this.isLoading = false
        }, 5000)
      }
    }
  }
}
